import { render, staticRenderFns } from "./ObjectObstructionsCreate.vue?vue&type=template&id=6ccf10b1&scoped=true"
import script from "./ObjectObstructionsCreate.vue?vue&type=script&lang=js"
export * from "./ObjectObstructionsCreate.vue?vue&type=script&lang=js"
import style0 from "./ObjectObstructionsCreate.vue?vue&type=style&index=0&id=6ccf10b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf10b1",
  null
  
)

export default component.exports